enum ProcessResultKeyEnum {
    ACCOUNT_BLOCKED = "ACCOUNT_BLOCKED",
    ACCOUNT_NOT_ACTIVE = "ACCOUNT_NOT_ACTIVE",
    ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
    AUTHORIZATION_BLOCKED = "AUTHORIZATION_BLOCKED",
    AUTHORIZATION_INVALID = "AUTHORIZATION_INVALID",
    CONTRACT_NOT_FOUND = "CONTRACT_NOT_FOUND",
    INVALID_CONTRACT = "INVALID_CONTRACT",
    INVALID_CONTRACT_DATA = "INVALID_CONTRACT_DATA",
    OTP_LIMIT_REACHED = "OTP_LIMIT_REACHED",
    OTP_NOT_READY_YET = "OTP_NOT_READY_YET",
    OTP_PHONE_BLOCKED = "OTP_PHONE_BLOCKED",
    REQUIRED_REDIRECT_URI = "REQUIRED_REDIRECT_URI",
    VERIFIED_MOBILE_NOT_FOUND = "VERIFIED_MOBILE_NOT_FOUND"
}

export default ProcessResultKeyEnum;
